<div class="emails-type-list">
  <ng-container *ngIf="!loadingSpinner">
    <div class="email-type" *ngFor="let dictWithTitle of dictionariesWithTitle let i = index">
      <div class="email-type-title">
        {{dictWithTitle.title}}

        <!--<i class="pi pi-plus-circle"></i>-->
      </div>
      <div class="email-type-body">
        <div class="email-change-buttons">
          <button mat-button class="email-changer-button"
                  *ngFor="let dictionary of dictWithTitle.dictionaries; let j = index"
                  [ngClass]="{'colored-button': dictionary.color !== '000000'}"
                  [style.background-color]="dictionary.color !== '000000' ? ('#' + dictionary.color) : '#e4e4e4'"
                  (click)="editDict(dictionary, i, j)">
            {{dictionary.title}} <ng-container *ngIf="dictionary.shortTitle"> ({{dictionary.shortTitle}})</ng-container>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="loading-body" *ngIf="loadingSpinner">
    <lib-progress-spinner></lib-progress-spinner>
  </div>
</div>
